import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.number.constructor.js";
import "core-js/modules/es6.object.define-property.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es6.array.for-each.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import "core-js/modules/es6.object.define-properties.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Utilities
import { mapState } from 'vuex';
import { themeColors } from '../../utils/themes';
export default {
  name: 'CoreFilter',
  data: function data() {
    return {
      colors: themeColors,
      mapStyles: [{
        text: 'niotix',
        value: '1'
      }, {
        text: 'Satellite',
        value: '2'
      }, {
        text: 'Streets',
        value: '3'
      }, {
        text: 'Combo',
        value: '4'
      }],
      mapStyle: localStorage.getItem('mapStyle')
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'drawer', 'UiTheme', 'map3DBuild', 'language', 'themes', 'miniVariant', 'color', 'colorHexLight', 'colorHexDark'])), {}, {
    lang: function lang() {
      return this.$store.state.app.language;
    },
    hasCustomColor: function hasCustomColor() {
      return this.UiTheme ? this.colorHexDark : this.colorHexLight;
    },
    isMobile: function isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    }
  }),
  methods: {
    resetDefaults: function resetDefaults() {
      localStorage.setItem('thingshiveColorLight', this.$store.state.app.themes.light.highlight);
      localStorage.setItem('thingshiveColorDark', this.$store.state.app.themes.dark.highlight);
      this.$store.state.app.UiTheme = this.$store.state.app.themeMode === 'dark';
      this.setUiTheme();
    },
    setColor: function setColor(color) {
      var mode = this.$store.state.app.UiTheme ? 'dark' : 'light';
      if (color === 'customerColor') {
        this.$store.state.app.color = mode === 'dark' ? 'customerColorDark' : 'customerColorLight';
      } else {
        this.$store.state.app.color = color;
      }
      if (mode === 'dark') {
        localStorage.setItem('thingshiveColorDark', this.$store.state.app.color);
      } else {
        localStorage.setItem('thingshiveColorLight', this.$store.state.app.color);
      }
    },
    mapLayoutSelected: function mapLayoutSelected() {
      localStorage.setItem('mapStyle', this.mapStyle);
      this.$store.state.app.mapStyle = this.mapStyle;
    },
    setLang: function setLang(lang) {
      this.$store.commit('app/language', {
        payload: lang,
        context: this
      });
      localStorage.setItem('language', lang);
    },
    setImage: function setImage(image) {
      this.$store.state.app.image = image;
      localStorage.setItem('thingshiveImage', this.$store.state.app.image);
    },
    setUiTheme: function setUiTheme() {
      var mode = this.$store.state.app.UiTheme ? 'dark' : 'light';
      var userHighlight = mode === 'dark' ? localStorage.getItem('thingshiveColorDark') : localStorage.getItem('thingshiveColorLight');
      localStorage.setItem('thingshiveTheme', mode);
      this.$store.state.app.color = userHighlight || this.themes[mode].highlight;
      this.$store.state.app.mode = mode;
      this.$vuetify.theme.dark = this.$store.state.app.UiTheme;
    },
    setMap3DBuild: function setMap3DBuild() {
      localStorage.setItem('thingshiveMap3DBuild', this.$store.state.app.map3DBuild ? '3D' : '2D');
    },
    setMiniVariant: function setMiniVariant() {
      localStorage.setItem('miniVariant', this.$store.state.app.miniVariant);
    },
    setLoader: function setLoader(a) {
      var b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      this.$store.state.app.load = a;
      this.$store.state.app.loading = b;
    }
  }
};